"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCss = exports.flush = exports.addCss = void 0;
var _react = _interopRequireDefault(require("react"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const rules = {};
let styleSheet;
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  styleSheet = (() => {
    const style = document.createElement('style');
    style.id = 'RNMQCSS';
    style.appendChild(document.createTextNode(''));
    document.head.appendChild(style);
    return style.sheet;
  })();
}
const hasCss = (id, text) => {
  return !!rules[id] && !!rules[id].text?.includes?.(text);
};
exports.hasCss = hasCss;
const addCss = (id, text) => {
  if (!hasCss(id, text)) {
    rules[id] = rules?.[id] || {};
    rules[id].text = (rules[id]?.text || '') + text;
    if (styleSheet) {
      styleSheet.insertRule(text, Object.keys(rules).length - 1);
    }
  }
};
exports.addCss = addCss;
const flush = () => {
  if (_Platform.default.OS === 'web') {
    return /*#__PURE__*/_react.default.createElement('style', {
      id: 'rnmq',
      key: 'rnmq',
      dangerouslySetInnerHTML: {
        __html: Object.keys(rules).map(key => rules[key].text).join('\n')
      }
    });
  }
  return {};
};
exports.flush = flush;